"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TryAgainFallbackComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@yanzi/react-ui");
function TryAgainFallbackComponent({ resetErrorBoundary, }) {
    return (jsx_runtime_1.jsxs(react_ui_1.Flex, Object.assign({ direction: "column", alignItems: "center", mx: "auto", my: "auto" }, { children: [jsx_runtime_1.jsx(react_ui_1.Box, { children: "An error occurred." }, void 0),
            jsx_runtime_1.jsx(react_ui_1.Button, Object.assign({ onClick: resetErrorBoundary }, { children: "Try again" }), void 0)] }), void 0));
}
exports.TryAgainFallbackComponent = TryAgainFallbackComponent;
//# sourceMappingURL=index.js.map